// extracted by mini-css-extract-plugin
export default {"tile":"battery-charge_tile__Uxy6A"};